import { IPageAction, IPageLink } from "../../../base/models"

import { AsideMenuItem } from "../../../../layout/components/aside/AsideMenuItem"
import { PageLinkHelper } from "../../../base/helpers"
import { Property } from "../../../base/types"
import { useGetProperties } from "../../../base/hooks"
import { useParams } from "react-router-dom"

export const AsideMenuActionPageLink = ({ action, hasBullet, className }: {
    action: IPageAction,
    hasBullet: boolean
    className?: string
}) => {
    const { siteId } = useParams()
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageLink: IPageLink | undefined = properties[Property.PageLink];

    if (!siteId || !pageLink)
        return <></>

    const pageUrl = PageLinkHelper.getPageLinkUrl(siteId, pageLink);

    return (
        <AsideMenuItem
            hasBullet={hasBullet}
            className={className}
            to={pageUrl}
            materialIcon={action.icon}
            title={action.name}
            fontIcon='bi-app-indicator'
        />)
}